"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _buildFlexProperties2 = _interopRequireDefault(require("./buildFlexProperties"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        display: ", ";\n        flex: ", ";\n        flex-direction: ", ";\n        flex-wrap: ", ";\n        justify-content: ", ";\n        align-items: ", ";\n        padding: ", " ", ";\n        ", "\n        ", "\n        ", "\n        /* The Below is used for giving flex children a gap similar to grid gap. Will only provide the gap if a marginY or X is provided */\n        & > * + * {\n          ", ";\n          ", ";\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FlexBox = function FlexBox(_ref) {
  var className = _ref.className,
      children = _ref.children,
      isVertical = _ref.isVertical,
      isInline = _ref.isInline,
      shouldWrap = _ref.shouldWrap,
      noGrow = _ref.noGrow,
      grow = _ref.grow,
      shrink = _ref.shrink,
      basis = _ref.basis,
      top = _ref.top,
      middle = _ref.middle,
      bottom = _ref.bottom,
      left = _ref.left,
      center = _ref.center,
      right = _ref.right,
      spaceBetween = _ref.spaceBetween,
      spaceAround = _ref.spaceAround,
      marginX = _ref.marginX,
      marginY = _ref.marginY,
      paddingX = _ref.paddingX,
      paddingY = _ref.paddingY,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "isVertical", "isInline", "shouldWrap", "noGrow", "grow", "shrink", "basis", "top", "middle", "bottom", "left", "center", "right", "spaceBetween", "spaceAround", "marginX", "marginY", "paddingX", "paddingY"]);
  var flexProperties = {
    isVertical: isVertical,
    top: top,
    middle: middle,
    bottom: bottom,
    left: left,
    center: center,
    right: right,
    spaceBetween: spaceBetween,
    spaceAround: spaceAround
  };

  var _buildFlexProperties = (0, _buildFlexProperties2["default"])(flexProperties),
      justifyContent = _buildFlexProperties.justifyContent,
      alignItems = _buildFlexProperties.alignItems;

  var layoutSizes = {
    xs: '0.25em',
    s: '0.5em',
    m: '0.75em',
    l: '1em',
    xl: '2em'
  };
  return _react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _emotion.cx)((0, _emotion.css)(_templateObject(), isInline ? 'inline-flex' : 'flex', noGrow ? '0 0 auto' : '1 1 auto', flexProperties.isVertical ? 'column' : 'row', shouldWrap ? 'wrap' : 'nowrap', justifyContent, alignItems, layoutSizes[paddingY] || 0, layoutSizes[paddingX] || 0, grow !== undefined && "flex-grow: ".concat(grow, ";"), shrink !== undefined && "flex-shrink: ".concat(shrink, ";"), basis !== undefined && "flex-basis: ".concat(basis, ";"), flexProperties.isVertical && layoutSizes[marginY] && "margin-top: ".concat(layoutSizes[marginY]), !flexProperties.isVertical && layoutSizes[marginX] && "margin-left: ".concat(layoutSizes[marginX])), className)
  }, restProps), children);
};

FlexBox.defaultProps = {
  className: ''
};
FlexBox.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  isVertical: _propTypes["default"].bool,
  isInline: _propTypes["default"].bool,
  noGrow: _propTypes["default"].bool,
  shouldWrap: _propTypes["default"].bool,
  grow: _propTypes["default"].number,
  shrink: _propTypes["default"].number,
  basis: _propTypes["default"].oneOf([_propTypes["default"].number, 'auto']),
  top: _propTypes["default"].bool,
  middle: _propTypes["default"].bool,
  bottom: _propTypes["default"].bool,
  left: _propTypes["default"].bool,
  center: _propTypes["default"].bool,
  right: _propTypes["default"].bool,
  spaceBetween: _propTypes["default"].bool,
  spaceAround: _propTypes["default"].bool,
  marginY: _propTypes["default"].oneOf(['xs', 's', 'm', 'l', 'xl']),
  marginX: _propTypes["default"].oneOf(['xs', 's', 'm', 'l', 'xl']),
  paddingX: _propTypes["default"].oneOf(['xs', 's', 'm', 'l', 'xl']),
  paddingY: _propTypes["default"].oneOf(['xs', 's', 'm', 'l', 'xl'])
};
var _default = FlexBox;
exports["default"] = _default;